import React from "react";
import UsersForm from "./UsersForm";

const AddUsers = () => {
  return <UsersForm />;
};

export default AddUsers;
